import { CommonModule, isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../shared/services/toast/toast.service';

@Component({
  selector: 'payment-result',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './payment.result.html',
  styleUrls: ['./payment.result.scss'],
})
export class PaymentResultComponent {
  _activatedRoute = inject(ActivatedRoute);
  _http = inject(HttpClient);
  _toast = inject(ToastService);
  sipayStatus: SipayStatus = SipayStatus.non;
  orderNo = '';
  invoiceId = '';
  orderId = '';
  hashKey = '';
  sipayStatusEnum = SipayStatus;
  checkIframeStatusInterval: any = null;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }
  ngOnInit() {
    this.checkParams();
  }
  ngAfterViewInit(): void {
    // Bu kod sadece browser tarafında çalışsın
    if (isPlatformBrowser(this.platformId)) {
      const removeUcMainDialog = () => {
        const el = document.getElementById('usercentrics-cmp-ui');
        if (el) {
          el.remove();
        }
      };

      // Sayfa yüklenince hemen kontrol et
      removeUcMainDialog();

      // DOM'a sonradan eklenirse yine sil
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          Array.from(mutation.addedNodes).forEach((node) => {
            if (node.nodeType === 1 && (node as HTMLElement).id === 'usercentrics-cmp-ui') {
              (node as HTMLElement).remove();
            }
          });
        });
      });

      // body içinde değişiklikleri izle
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }
  checkParams() {
    this._activatedRoute.queryParams.pipe(first()).subscribe((params) => {
      this.invoiceId = params['invoice_id'];
      const localInvoiceId = (typeof localStorage !== 'undefined') ? localStorage.getItem('invoice_id') : null;
      if (this.invoiceId && this.invoiceId != localInvoiceId) {
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem('invoice_id', this.invoiceId);
        }
        const md_status = params['md_status'];
        if (params) {
          if (md_status != '1') {
            let error = params['error'];
            if (typeof localStorage !== 'undefined') {
              localStorage.setItem('sipay_error', error);
            }
            if (typeof window !== 'undefined' && window.parent) {
              window.parent.postMessage({ type: 'paymentResult', status: 'error', errorMessage: params['status_description'] }, '*');
            }
            this.sipayStatus = SipayStatus.cancel;
            return;
          }
          else {
            const headers = {
              skip: 'true',
            };
            const url = environment.apiUrl + '/Payment/HandlePayment';
            this._http.post(url, params).subscribe((response: any) => {
              if (response.status_code === '100') {
                if (typeof window !== 'undefined' && window.parent) {
                  window.parent.postMessage({ type: 'paymentResult', status: 'success' }, '*');
                }
                this.sipayStatus = SipayStatus.success;
              } else {
                if (typeof window !== 'undefined' && window.parent) {
                  window.parent.postMessage({ type: 'paymentResult', status: 'error' , errorMessage: response.status_description}, '*');
                }
                this.sipayStatus = SipayStatus.cancel;
              }
            });
          }
        } else {
          this.sipayStatus = SipayStatus.cancel;
        }
      } else {
        this.sipayStatus = SipayStatus.cancel;
      }
    });
  }
}

export enum SipayStatus {
  cancel,
  success,
  non,
}
